import { useReducer, Dispatch, Reducer, useEffect } from 'react';
import { localCache } from '../util/localCache';
import { merge } from 'lodash';

// Reference: https://dev.to/sgolovine/persisting-usereducer-with-a-custom-react-hook-1j27
export const usePersistedReducer = <S, A>(
  storageKey: string,
  reducer: Reducer<S, A>,
  initialState: S
): [S, Dispatch<A>] => {
  const init = (): S => merge({}, initialState, localCache.get(storageKey, {}));

  const [state, dispatch] = useReducer(reducer, initialState, init);

  useEffect(() => {
    localCache.set(storageKey, state);
  }, [state]);

  return [state, dispatch];
};
